module.exports = __webpack_public_path__ + "img/swap.a03c0920.svg";